<div class="pb-6" id="home">
  <div class="px-6 py-10 homepage-header">
    <span [class]="auth.isAuthenticated$ ? 'text-5xl' : 'text-7xl'" class="font-bold flex justify-center flex-col
    ">
      <span class="flex items-center justify-center flex-wrap font-black pb-3">
        BioConnect
        <p-divider layout="vertical"></p-divider>
        <b class="font-normal" [class]="auth.isAuthenticated$ ? 'text-4xl' : 'text-5xl'">The Jackson Laboratory</b>
      </span>
      <div class="flex justify-center text-xl font-norma">
        A digital catalog of investigations, studies, assays, and datasets.
      </div>
      <br />
      <div class="flex justify-center gap-4 flex-wrap">
        <button pButton type="button"
          class="text-lg px-12 font-bold border-none rounded-border bg-white text-primary-700 p-button-raised"
          label="Explore the Catalog" routerLink="/search"></button>
        <button pButton type="button"
          class="text-lg px-12 font-bold border-none rounded-border bg-white text-primary-700 p-button-raised"
          label="Contribute Study Data" routerLink="/curation"></button>
        <a href="https://docs.bioconnect.jax.org/home/quick-start/" target="_blank"
          class="p-button text-sm px-12 font-bold rounded-border bg-transparent text-black border-black p-button-raised"
          label="Take a Quick Tour">Take a Quick Tour</a>
      </div>


    </span>
    <br />
  </div>
  <div class="px-10">
    @let isAuthenticated = (auth.isAuthenticated$ | async) === true;
    <div class="content-container" [class.no-video]="isAuthenticated">
      <div class="text-column">
        <div class="text-content">
          <p class="p-2">
            JAX BioConnect is a searchable catalog of data as a part of The Jackson Laboratory's FAIR data ecosystem.
            Data
            are
            from a wide variety of studies, both internal and external to JAX. For some studies, BioConnect is the
            repository
            of record. Some studies are indexed here for convenience and stored elsewhere.
          </p>
          <p class="p-2">
            <strong>Your studies are welcome!</strong> Please send a note to
            <a href="mailto:bioconnect_support@jax.org" class="external-link">bioconnect_support&#64;jax.org</a> to
            become
            a
            contributor, or join the twice-monthly office hours online or in person.

            <a href="https://jacksonlaboratory.sharepoint.com/sites/JAXDataScience/_layouts/15/Events.aspx?Page=%2fsites%2fJAXDataScience%2fSitePages%2fHome.aspx&InstanceId=9bc50d72-31fb-4768-8a5d-0bf034ab7eb8&Category=&StartDate=2026-08-24&EndDate=2026-09-23&AudienceTarget=false" 
            target="_blank" class="external-link">See the office hours schedule</a>.

            <br />
            Study data remains private until you choose to open it to the community.
            <br />
          </p>
        </div>
      </div>
      <div class="py-2 data-use-guidelines">
        <div class="font-bold pt-3 text-3xl">Data Use Guidelines</div>
        <p class="p-2">
          Data shared here are open to the JAX community for research use.
          Please send a note to <a href="mailto:bioconnect_support@jax.org"
            class="external-link">bioconnect_support&#64;jax.org</a>
          to coordinate data re-use and publication plans, or speak directly with contacts
          listed under the study of interest.
        </p>
      </div>
      @if (!isAuthenticated) {
      <div class="video-container">
        <div style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden;">
          <iframe [src]="videoUrl" width="100%" height="100%" frameborder="0" allow="autoplay" allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none;">
          </iframe>
        </div>
        <div class="video-caption p-2">
          Video: A short overview summarizing the features of BioConnect
        </div>
      </div>
      }



    </div>

    @if (isAuthenticated) {
    <bioconnect-ui-statistics></bioconnect-ui-statistics><br /><br />
    }

    @if (isAuthenticated) {
    <bioconnect-ui-tile-nav></bioconnect-ui-tile-nav>
    }

  </div>
</div>